const t = {
  en: {
    // NAV
    home: 'Home',
    services: 'Services',
    contact: 'Contact Us',

    // HERO
    eyebrow: 'Trusted Property Maintenance',
    hero_h1_1: 'Your Property',
    hero_h1_2: 'Deserves the',
    hero_highlight: 'Best Care',
    hero_p: "We handle repairs, installations, and outdoor services so you don't have to. Reliable, professional, and always on time.",
    hero_cta: 'Request a Quote',
    hero_badge1: 'Licensed & Insured ✓',
    hero_badge2: 'Bilingual 🇺🇸🇪🇸',

    // TRUST
    trust1: 'Reliable Service', trust2: '5-Star Quality', trust3: 'Fully Insured',
    trust4: 'Serving Florida', trust5: 'English & Spanish',

    // SERVICES SECTION
    services_tag: 'What We Do',
    services_h2_1: 'Complete Property',
    services_h2_2: 'Maintenance',
    services_p: 'From minor repairs to full outdoor transformations, we keep every corner of your property in top condition.',
    view_all: 'View All Services →',

    // SERVICE CARDS
    svc1_title: 'Property Maintenance',
    svc1_desc: 'Ongoing care and upkeep to protect the value of your property year-round.',
    svc1_items: ['Preventive Maintenance', 'General Property Upkeep', 'Common Area Maintenance', 'Scheduled Inspections'],

    svc2_title: 'Repairs & Installations',
    svc2_desc: 'Fast, professional repairs and installations handled by experienced technicians.',
    svc2_items: ['Doors, Locks & Hardware', 'General Repairs', 'Fixture Installations', 'Drywall & Painting'],

    svc3_title: 'Outdoor Services',
    svc3_desc: 'Keep the exterior of your property clean, green, and welcoming all season long.',
    svc3_items: ['Lawn Maintenance', 'Garden Care & Landscaping', 'Cleanup & Debris Removal', 'Seasonal Prep'],

    // WHY
    why_tag: 'Why XSC Invest',
    why_h2_1: 'The Standard You',
    why_h2_2: 'Deserve',
    why_p: "We don't just fix things. We build lasting relationships with property owners who expect the best.",
    why1_title: 'Responsive & On Time', why1_desc: "We show up when we say we will. No waiting, no excuses. Your schedule is our schedule.",
    why2_title: 'Transparent Pricing', why2_desc: "No hidden fees or surprise charges. You know exactly what you're paying for before we start.",
    why3_title: 'Quality Workmanship', why3_desc: "Every job is done right the first time. We stand behind our work with a satisfaction guarantee.",
    why4_title: 'Bilingual Communication', why4_desc: "We speak both English and Spanish fluently — no miscommunication, no barriers.",

    // BILINGUAL
    bil_tag: 'Serving Our Community',
    bil_h2_1: 'We Speak Your',
    bil_h2_2: 'Language',
    bil_p1: "XSC Invest proudly serves both English- and Spanish-speaking clients throughout Florida. Clear communication matters — we make sure nothing gets lost in translation.",
    bil_p2: "Desde reparaciones menores hasta mantenimiento integral, estamos aquí para ayudarte en el idioma que prefieras.",
    bil_quote_en: 'Your Property,',
    bil_quote_en2: 'Our Priority.',
    bil_quote_es: 'Su Propiedad,',
    bil_quote_es2: 'Nuestra Prioridad.',

    // CTA
    cta_tag: 'Get in Touch',
    cta_h2_1: 'Ready to Get',
    cta_h2_2: 'Started?',
    cta_p: "Reach out for a free, no-obligation quote. We'll assess your needs and get back to you promptly.",
    cta_btn: 'Contact Us Now',
    cta_box_h3: 'Get a Free Quote Today',
    cta_box_p: "No obligation. We'll review your needs and respond within 24 hours.",

    // SERVICES PAGE
    sp_eyebrow: 'What We Offer',
    sp_h1_1: 'Professional Services',
    sp_h1_2: 'for Every',
    sp_h1_highlight: 'Property Need',
    sp_p: 'From routine maintenance to complete outdoor transformations — we have the expertise to handle it all, on time and on budget.',
    sp_cta_h2: 'Get a Free Quote for Any of Our Services',
    sp_cta_span: 'Ready to get started?',
    sp_cta_btn: 'Contact Us Now',
    sp_note1: 'Available on a contract basis. Monthly and quarterly maintenance plans available for residential and commercial properties in Florida.',
    sp_note2: 'Same-week scheduling available. We prioritize urgent repairs and always communicate timelines clearly before starting any work.',
    sp_note3: 'Weekly and bi-weekly plans available. Serving residential neighborhoods, HOA communities, and commercial properties throughout Florida.',

    // CONTACT PAGE
    cp_eyebrow: 'Get in Touch',
    cp_h1_1: "Let's Talk About",
    cp_h1_2: 'Your',
    cp_h1_highlight: 'Property',
    cp_p: 'Request a free, no-obligation quote. We respond within 24 hours and are happy to assist in English or Spanish.',
    cp_tag: 'Reach Us Directly',
    cp_h2_1: "We're Here to",
    cp_h2_2: 'Help',
    cp_sidebar_p: "Whether you need an urgent repair or want to set up ongoing maintenance, we're just a call or message away.",
    cp_hours: 'Business Hours',
    cp_days: 'Monday – Sunday',
    cp_form_h3: 'Request a Free Quote',
    cp_form_sub: "Fill out the form and we'll get back to you within one business day.",
    cp_fname: 'First Name', cp_lname: 'Last Name',
    cp_phone: 'Phone Number', cp_email: 'Email Address',
    cp_prop: 'Property Type', cp_prop_placeholder: 'Select property type...',
    cp_prop_types: ['Residential – Single Family Home', 'Residential – Condo / Apartment', 'Commercial – Office / Retail', 'Commercial – Multi-Family', 'HOA / Community', 'Other'],
    cp_services_label: 'Services Needed',
    cp_service_options: ['Property Maintenance', 'Repairs & Installations', 'Outdoor / Lawn Services', 'Other / Not Sure Yet'],
    cp_message: 'Message', cp_message_placeholder: 'Tell us about your property and what you need...',
    cp_submit: 'Send Request',
    cp_note: 'No spam, ever. Your information is kept private and used only to respond to your inquiry.',
    cp_success_h3: 'Message Sent!',
    cp_success_p: 'Thank you for reaching out. Ángel will review your request and get back to you within one business day.',
    cp_success_p2: 'In the meantime, feel free to call us at',
    cp_required: 'Please fill in name & phone',

    // FOOTER
    ft_nav: 'Navigation', ft_contact: 'Contact',
    ft_rights: '© 2026 XSC Invest. All rights reserved.',
    ft_tagline: 'Your Property, Our Priority',
    ft_desc: 'Professional property maintenance serving Florida\'s residential and commercial clients. Reliable, bilingual, and always committed to quality.',
  },

  es: {
    // NAV
    home: 'Inicio',
    services: 'Servicios',
    contact: 'Contáctenos',

    // HERO
    eyebrow: 'Mantenimiento de Propiedades de Confianza',
    hero_h1_1: 'Su Propiedad',
    hero_h1_2: 'Merece el',
    hero_highlight: 'Mejor Cuidado',
    hero_p: 'Nos encargamos de reparaciones, instalaciones y servicios exteriores para que usted no tenga que hacerlo. Confiables, profesionales y siempre a tiempo.',
    hero_cta: 'Solicitar Cotización',
    hero_badge1: 'Licenciado y Asegurado ✓',
    hero_badge2: 'Bilingüe 🇺🇸🇪🇸',

    // TRUST
    trust1: 'Servicio Confiable', trust2: 'Calidad 5 Estrellas', trust3: 'Totalmente Asegurado',
    trust4: 'Sirviendo Florida', trust5: 'Inglés y Español',

    // SERVICES SECTION
    services_tag: 'Lo Que Hacemos',
    services_h2_1: 'Mantenimiento',
    services_h2_2: 'Completo de Propiedades',
    services_p: 'Desde reparaciones menores hasta transformaciones exteriores completas, mantenemos cada rincón de su propiedad en óptimas condiciones.',
    view_all: 'Ver Todos los Servicios →',

    // SERVICE CARDS
    svc1_title: 'Mantenimiento de Propiedades',
    svc1_desc: 'Cuidado continuo para proteger el valor de su propiedad durante todo el año.',
    svc1_items: ['Mantenimiento Preventivo', 'Cuidado General de la Propiedad', 'Mantenimiento de Áreas Comunes', 'Inspecciones Programadas'],

    svc2_title: 'Reparaciones e Instalaciones',
    svc2_desc: 'Reparaciones e instalaciones rápidas y profesionales realizadas por técnicos experimentados.',
    svc2_items: ['Puertas, Cerraduras y Herrajes', 'Reparaciones Generales', 'Instalación de Accesorios', 'Drywall y Pintura'],

    svc3_title: 'Servicios Exteriores',
    svc3_desc: 'Mantenga el exterior de su propiedad limpio, verde y acogedor durante toda la temporada.',
    svc3_items: ['Mantenimiento de Césped', 'Cuidado de Jardines y Paisajismo', 'Limpieza y Remoción de Escombros', 'Preparación por Temporada'],

    // WHY
    why_tag: 'Por Qué XSC Invest',
    why_h2_1: 'El Estándar Que',
    why_h2_2: 'Usted Merece',
    why_p: 'No solo arreglamos cosas. Construimos relaciones duraderas con propietarios que esperan lo mejor.',
    why1_title: 'Puntuales y Responsables', why1_desc: 'Llegamos cuando decimos que llegamos. Sin esperas, sin excusas. Su horario es nuestro horario.',
    why2_title: 'Precios Transparentes', why2_desc: 'Sin cargos ocultos ni sorpresas. Usted sabe exactamente lo que paga antes de que empecemos.',
    why3_title: 'Trabajo de Calidad', why3_desc: 'Cada trabajo se hace bien desde la primera vez. Respaldamos nuestro trabajo con garantía de satisfacción.',
    why4_title: 'Comunicación Bilingüe', why4_desc: 'Hablamos inglés y español con fluidez — sin malentendidos, sin barreras.',

    // BILINGUAL
    bil_tag: 'Sirviendo Nuestra Comunidad',
    bil_h2_1: 'Hablamos Su',
    bil_h2_2: 'Idioma',
    bil_p1: 'XSC Invest sirve con orgullo a clientes de habla inglesa y española en toda Florida. La comunicación clara importa — nos aseguramos de que nada se pierda en la traducción.',
    bil_p2: 'From minor repairs to full property maintenance, we are here to help you in the language you prefer.',
    bil_quote_en: 'Your Property,',
    bil_quote_en2: 'Our Priority.',
    bil_quote_es: 'Su Propiedad,',
    bil_quote_es2: 'Nuestra Prioridad.',

    // CTA
    cta_tag: 'Contáctenos',
    cta_h2_1: '¿Listo para',
    cta_h2_2: 'Comenzar?',
    cta_p: 'Contáctenos para una cotización gratuita sin compromiso. Evaluaremos sus necesidades y le responderemos pronto.',
    cta_btn: 'Contáctenos Ahora',
    cta_box_h3: 'Obtenga una Cotización Gratis Hoy',
    cta_box_p: 'Sin compromiso. Revisaremos sus necesidades y responderemos en 24 horas.',

    // SERVICES PAGE
    sp_eyebrow: 'Lo Que Ofrecemos',
    sp_h1_1: 'Servicios Profesionales',
    sp_h1_2: 'para Cada',
    sp_h1_highlight: 'Necesidad de Propiedad',
    sp_p: 'Desde mantenimiento rutinario hasta transformaciones exteriores completas — tenemos la experiencia para manejarlo todo, a tiempo y dentro del presupuesto.',
    sp_cta_h2: 'Obtenga una Cotización Gratis para Cualquier Servicio',
    sp_cta_span: '¿Listo para comenzar?',
    sp_cta_btn: 'Contáctenos Ahora',
    sp_note1: 'Disponible por contrato. Planes de mantenimiento mensuales y trimestrales disponibles para propiedades residenciales y comerciales en Florida.',
    sp_note2: 'Programación disponible la misma semana. Priorizamos reparaciones urgentes y siempre comunicamos los tiempos claramente antes de comenzar.',
    sp_note3: 'Planes semanales y quincenales disponibles. Atendemos vecindarios residenciales, comunidades HOA y propiedades comerciales en toda Florida.',

    // CONTACT PAGE
    cp_eyebrow: 'Contáctenos',
    cp_h1_1: 'Hablemos Sobre',
    cp_h1_2: 'Su',
    cp_h1_highlight: 'Propiedad',
    cp_p: 'Solicite una cotización gratuita sin compromiso. Respondemos en 24 horas y con gusto le atendemos en inglés o español.',
    cp_tag: 'Contáctenos Directamente',
    cp_h2_1: 'Estamos Aquí para',
    cp_h2_2: 'Ayudarle',
    cp_sidebar_p: 'Ya sea que necesite una reparación urgente o quiera establecer un mantenimiento continuo, estamos a solo una llamada o mensaje de distancia.',
    cp_hours: 'Horario de Atención',
    cp_days: 'Lunes – Domingo',
    cp_form_h3: 'Solicitar Cotización Gratis',
    cp_form_sub: 'Complete el formulario y le responderemos en un día hábil.',
    cp_fname: 'Nombre', cp_lname: 'Apellido',
    cp_phone: 'Número de Teléfono', cp_email: 'Correo Electrónico',
    cp_prop: 'Tipo de Propiedad', cp_prop_placeholder: 'Seleccione el tipo de propiedad...',
    cp_prop_types: ['Residencial – Casa Unifamiliar', 'Residencial – Condominio / Apartamento', 'Comercial – Oficina / Local', 'Comercial – Multifamiliar', 'HOA / Comunidad', 'Otro'],
    cp_services_label: 'Servicios Necesarios',
    cp_service_options: ['Mantenimiento de Propiedades', 'Reparaciones e Instalaciones', 'Servicios Exteriores / Césped', 'Otro / No estoy seguro aún'],
    cp_message: 'Mensaje', cp_message_placeholder: 'Cuéntenos sobre su propiedad y lo que necesita...',
    cp_submit: 'Enviar Solicitud',
    cp_note: 'Sin spam. Su información es privada y solo se usa para responder a su consulta.',
    cp_success_h3: '¡Mensaje Enviado!',
    cp_success_p: 'Gracias por contactarnos. Ángel revisará su solicitud y le responderá en un día hábil.',
    cp_success_p2: 'Mientras tanto, puede llamarnos al',
    cp_required: 'Por favor complete nombre y teléfono',

    // FOOTER
    ft_nav: 'Navegación', ft_contact: 'Contacto',
    ft_rights: '© 2026 XSC Invest. Todos los derechos reservados.',
    ft_tagline: 'Su Propiedad, Nuestra Prioridad',
    ft_desc: 'Mantenimiento profesional de propiedades sirviendo a clientes residenciales y comerciales de Florida. Confiables, bilingües y siempre comprometidos con la calidad.',
  }
};

export default t;
